
export default {
  name: 'home',
  components: {

  },
  data() {
    return {
      list: [],
      shows: false,
      shopInfo: {}
    }
  },
  created() {
  },
  mounted: function () {
    this.getList()
  },
  methods: {
    getCode: function (item) {
      console.log(item)
      this.apiGet('/h5/api/user/getBusinessInfos', { businessId: item.b_id }, res => {
        if (res.state) {
          this.shopInfo = res.data || {}
          this.shows = true
        } else {
          this.$message(res.msg)
        }
      })
    },
    toWithdrawal: function (item) {
      this.$router.push({
        path: '/withdrawal',
        query: {
          bid: item.b_id,
          total_withdrawal: item.total_withdrawal,
          validmoney: item.validmoney
        }
      })
    },
    toHb: function () {
      this.$message('正在开发')
    },
    toLinks: function () {
      this.$router.push({ path: '/links' })
    },

    toMy: function () {
      this.$router.push({ path: '/my' })
    },
    toHome: function () {
      this.$router.push({ path: '/home' })
    },

    toList: function () {
      this.$router.push({ path: '/list' })
    },
    backPage: function () {
      window.history.go(-1)
    },
    getList: function () {
      this.list = []
      this.apiGet('/h5/api/user/account/getList', '', res => {
        if (res.state) {
          this.list = res.data || []
        } else {
          this.$message(res.msg)
        }
      })
    },
    // 一键提现
    toWithdrawalAll: function (item) {
      let that = this;
      this.$alert(`<div style="font-size:18px;line-height:30px;color:red;" class="sky">一键提现，将提现所有钱包余额。若出现未到账情况，请检查提现记录。请确认是否使用一键提现</div>`, '', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '一键提现',
        callback: action => {
          console.log(action)
          if (action == 'confirm') {
            that.apiGet('/h5/api/user/withdrawal/oneKeyWithdrawal', '', res => {
              if (res.state) {
                that.$message({ message: res.msg, type: 'success' });
                that.getList()
              } else {
                that.$message(res.msg)
              }
            })
          }
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/account-list/account-list.js